<form #AnexosForm="ngForm">
    <app-custom-modal #modal [title]="'Enviar Exame'" [subtitle]="''" (onCloseClick)="modal.close()"
        (onSaveClick)="save()" [saveLabel]="'Enviar →'" [saveDisabled]="saving">
        <div class="container">
            <div class="mb-4">
                <label for="selectPedido" class="form-label required">Pedido</label>
                <select name="selectPedido" id="selectPedido" class="form-control" [(ngModel)]="solicitacaoId">
                    <option *ngFor="let pedido of pedidos" [value]="pedido.id">{{pedido.descricao}}</option>
                </select>
            </div>
            <div *ngIf="solicitacaoId" class="mb-4">
                <label for="" class="form-label required">Arquivo</label>
                <div class="custom-file file-upload-custom">
                    <input type="file" class="custom-file-input" id="file" (change)="handleUpload($event)"
                        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel,application/pdf,application/vnd.ms-powerpoint,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.presentationml.slideshow,application/vnd.openxmlformats-officedocument.presentationml.presentation,text/plain,image/*,audio/*,video/*">
                    <label class="custom-file-label" for="file" data-browse="Buscar">
                        Clique para selecionar o arquivo...</label>
                    <small *ngIf="exame" class="form-text text-muted">
                        {{ exame?.fileNameWithOutExtension }}</small>
                </div>
            </div>
        </div>
    </app-custom-modal>
</form>